<!-- forecastpredict -->
<template>
  <div class="right">

    <rightTop @data="getCreditDataFn"></rightTop>


    <div class="rightCenter">
      <div class="centerTit">股东大会通知</div>
      <div style="width:80%;position: relative;">
        <div @click="downloadFn(0)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:21px;margin-left:20px;">
          <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
          <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
        </div>
        <div style="width:296px;float:right;position: relative;">
          <el-select @change="SelectTimeFn1" v-model="searchData1.value" size="small" placeholder="请选择">
            <el-option
              v-for="item in searchData1.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 61px;vertical-align: middle;line-height: 61px;color: #fff;">公告日期：</div>
          <!-- <div @click="SelectTimeFn1" style="position: absolute;top: 0;left:0;width:100%;height: 100%;cursor: pointer;"></div> -->
        </div>
        <el-card class="box-card SelectAlert" style="position: absolute;top:54px;right:19%;width:335px;height:302px;z-index: 1000000;display: none;">
          <h5 style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:#000;line-height:1;margin-bottom:23px;">日期范围</h5>
          <el-radio-group v-model="changeTime.radio">
            <el-radio :label="2" style="width:40px;color:#000000;">近两年</el-radio>
            <el-radio :label="3" style="width:40px;color:#000000;">近三年</el-radio>
            <el-radio :label="5" style="width:40px;color:#000000;">近五年</el-radio>
            <el-radio :label="10" style="width:40px;color:#000000;">近十年</el-radio>
            <el-radio :label="-1" style="width:80px;display: inline-block;margin-top:30px;margin-right:0;color:#000000;">自定义</el-radio>
            <el-input @focus="startTimeFn" @blur="startTimeTestFn(1)" v-model="changeTime.startTime" placeholder="2010-11" size="mini" style="display: inline-block;width:90px;"></el-input>
            <span style="display: inline-block;width:8px;height: 1px;position: relative;top: -4px;background:#000;margin:0 10px;"></span>
            <el-input @focus="startTimeFn" @blur="startTimeTestFn(2)" v-model="changeTime.endTime" placeholder="2010-11" size="mini" style="display: inline-block;width:90px;"></el-input>
          </el-radio-group>
          <div style="width:98%;height:1px;background:#DFDFDF;margin-top:21px;margin-bottom:20px;"></div>
          <h5 style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:#000;line-height:1;">报告期</h5>
          <el-checkbox-group v-model="changeTime.checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in changeTime.cities" :label="city" :key="city" style="width:45px;color:#000000;">{{city}}</el-checkbox>
          </el-checkbox-group>
          <div style="height: 40px;line-height:1;text-align: center;">
            <el-button @click="changeTimeTrue" type="primary" size="mini">确定</el-button>
            <el-button @click="changeTimeClose" type="info" size="mini">关闭</el-button>
          </div>
        </el-card>
      </div>
    </div>
    <div class="rightBottom">
      <!-- 第一套 -->
      <div class="tabulation">
        <table class="mailTable">
            <tr>
                <td class="column">会议类型</td>
                <td>{{tableData1.meetingsType}}</td>
            </tr>
            <tr>
                <td class="column">召开方式</td>
                <td>{{tableData1.conveningMode}}</td>
            </tr>
            <tr>
                <td class="column">议题</td>
                <td>{{tableData1.issue}}</td>
            </tr>
            <tr>
                <td class="column">审议内容</td>
                <td>{{tableData1.consideration}}</td>
            </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
import $ from 'jquery';
export default {
  data() {
    return {
      tableData1:{},
      //选择数据
      searchData1:{
        select:[],//下拉框选项数据
        value: '',
      },
      companyList:[],
      paramsData:{},//URL参数集合
      changeTime:{//报表范围选项数据
        radio:'',
        startTime:'',
        endTime:'',
        checkedCities: ['一季度', '中报', '三季度', '年报'],
        cities: ['一季度', '中报', '三季度', '年报'],
      },
      styles:[]//获取表格加粗集合
    };
  },
  watch: {
    changeTime:{
      handler(val, oldVal){
        // console.log(val.radio, oldVal.radio,'val1');
        if(val.radio != -1){
          this.changeTime.endTime = '';
          this.changeTime.startTime = '';
        }
      },
      deep:true //true 深度监听
    }
  },
  components:{
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data,'mytest')
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.fetchTimes();
      setTimeout(()=>{this.action()},300)//获取表格数据
      
    },
    //筛选条件确定按钮
    changeTimeTrue(){
      let startDate = '';
      let endDate = '';
      let reportDate = '';
      
      if(this.changeTime.radio == -1){//开始结束时间写了就要写完整
        if(this.changeTime.startTime == ''){
          this.$message.error('请填写开始时间！');
          return;
        }
        if(this.changeTime.endTime == ''){
          this.$message.error('请填写结束时间！');
          return;
        }
        startDate = this.changeTime.startTime;
        endDate = this.changeTime.endTime;
      }else{
        if(this.changeTime.radio == ''){
          startDate = '';
          endDate = '';
        }else{
          startDate = magic.getSomeYearsBefor(this.changeTime.radio).substring(0,7);
          endDate = magic.getSomeYearsBefor(0).substring(0,7);
        }
      }
      if(this.changeTime.checkedCities.length == 0){//报告期要至少选一个
        this.$message.error('请选择报告期！');
        return;
      }
      let tmpArr = this.changeTime.checkedCities;
      for(var i=0;i<tmpArr.length;i++){
        
        if(tmpArr[i] == '一季度'){
          tmpArr.length-1 == i ? reportDate += '03' : reportDate += '03,';
        }
        if(tmpArr[i] == '中报'){
          tmpArr.length-1 == i ? reportDate += '06' : reportDate += '06,';
        }
        if(tmpArr[i] == '三季度'){
          tmpArr.length-1 == i ? reportDate += '09' : reportDate += '09,';
        }
        if(tmpArr[i] == '年报'){
          tmpArr.length-1 == i ? reportDate += '12' : reportDate += '12,';
        }
      }
      console.log(startDate,endDate,reportDate);

      setTimeout(()=>{
        this.fetchTable1(this.paramsData.stockCode, this.paramsData.enterpriseCode, startDate, endDate, reportDate);//按产品
        $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'14px','font-weight':'400'});
        $('.SelectAlert').css('display','none');
      },900)
    },
    //日期正则校验
    isDate(dateString) {
      if(dateString.trim()=="")return false;
      //年月日正则表达式
      var r=dateString.match(/^(\d{1,4})(-)(\d{1,2})$/); 
      if(r==null){
        return false;
      }
      return true;
    },
    //筛选条件关闭按钮
    changeTimeClose(){
      $('.SelectAlert').css('display','none');
    },
    //日期范围里时间段input函数
    startTimeFn(){
      this.changeTime.radio = -1;
    },
    // 日期输入框正则校验
    startTimeTestFn(num){
      let bool = '';
      if(num == 1){
        bool = this.isDate(this.changeTime.startTime);
      }
      if(num == 2){
        bool = this.isDate(this.changeTime.endTime);
      }
      if(!bool){
        this.$message.error('请输入正确的时间格式！');
        num == 1 ? this.changeTime.startTime = '' : this.changeTime.endTime = '';
      }
    },
    //多选框函数
    handleCheckedCitiesChange(value){
      console.log(value,'value')
    },
    cellStyle(row, column, rowIndex, columnIndex){
      //styles
      let _this = this;
      console.log(row.row[0])
      if(row.columnIndex == 0){
        if(_this.styles.length > 0){
          for(let i=0;i<_this.styles.length;i++){
            if(row.row[0] == _this.styles[i]){
              return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
            }
          }
        }
        return 'color: #333333;font-family:Microsoft YaHei;background:#F7F7F7;'
      }
      if(row.rowIndex == 0){
        return 'color: #333333;font-family:Microsoft YaHei;background:#F7F7F7;'
      }
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      this.download(window.baseUrl + '/matters/downMeetingNoticeData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val){
      console.log(val,'val');
      this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,val);//按产品
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
      }catch(e){}
    },
    //获取所有时间的选项
    fetchTimes(){
      let _this = this;
      api.meetingnoticeTimeOne(this.paramsData.stockCode,this.paramsData.enterpriseCode).then(res=>{
        let data = res.data;
        _this.searchData1.select = data;
        _this.searchData1.value = data[0];
      })   
    },
    action(){
      setTimeout(()=>{
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.searchData1.value);//按产品
        $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'14px','font-weight':'400'});
      },900)
    },
    fetchTable1(stockCode,enterpriseCode,reportDate){
      let _this = this;
      
      api.meetingnoticeOne(stockCode, enterpriseCode, reportDate).then(res=>{
          let data = res.data;
          console.log(data,'data1');
          _this.tableData1 = data;
      })   
    }
  },
  
  mounted() {
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    overflow:hidden;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
      overflow:hidden;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #08396A; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #08396A; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; color: #dfecf7; }
.mailTable tr td.column { background-color: #375572;  color: #dfecf7; font-size:14px;font-weight:bold;width:20%;}
.el-table thead{
  background-color: #F7F7F7!important; 
  color: #333333!important;
  font-size:14px!important;
  font-weight:bold!important;
}

</style>


// WEBPACK FOOTER //
// src/view/majorevents/meetingnotice.vue